/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumComunicazioneDTOCodiceStatoRegistrazioneUscita =
  (typeof EnumComunicazioneDTOCodiceStatoRegistrazioneUscita)[keyof typeof EnumComunicazioneDTOCodiceStatoRegistrazioneUscita];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumComunicazioneDTOCodiceStatoRegistrazioneUscita = {
  IN_LAVORAZIONE: 'IN_LAVORAZIONE',
  SUCCESSO: 'SUCCESSO',
  FALLIMENTO: 'FALLIMENTO',
} as const;
